module.exports = __webpack_public_path__ + "img/1495124449.5f96d1ad.jpg";